module.exports = "<div class=row> <side-nav fixed> <nav-item><a href=#! class=\"waves-effect waves-teal\">Link 1</a></nav-item> <nav-item><a href=#! class=\"waves-effect waves-teal\">Link 2</a></nav-item> <nav-collapsible-item> <collapsible-header label=\"dropdown menu\" icon=arrow_drop_down icon-position=right></collapsible-header> <collapsible-body> <ul> <nav-item><a href=#!>Link 3</a></nav-item> <nav-item><a href=#!>Link 4</a></nav-item> </ul> </collapsible-body> </nav-collapsible-item> </side-nav> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/side-nav/side-nav-demo.vue
 ** module id = 355
 ** module chunks = 0
 **/